import HomeOutlined from "@mui/icons-material/HomeOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { FC } from "react";

export const Error: FC<{
	src?: string;
	title?: string;
	description?: string;
	callback?: () => void | Promise<void>;
}> = ({
	src = "/images/500.webp",
	title = "OOPS!",
	description = "Something went wrong. Check back with us later.",
	callback,
}) => {
	return (
		<Box
			height="100vh"
			display="flex"
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
			px={4}
			gap={2}
			textAlign="center">
			<img
				src={src}
				width="250px"
			/>
			<Typography variant="h6">{title}</Typography>
			<Typography
				variant="body2"
				color="text.secondary">
				{description}
			</Typography>
			<Button
				color="primary"
				variant="contained"
				startIcon={<HomeOutlined />}
				onClick={async () => {
					await callback?.();
					window.location.href = "/";
				}}>
				Back to home
			</Button>
		</Box>
	);
};
